<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="tree img-w">
    <svg viewBox="0 0 98 185" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M65.5641 19.2454H50.7536L58.7861 11.1965L57.6456 10.0397L49.5967 18.0885V0.0518799H47.9674V18.0885L39.9185 10.0397L38.7617 11.1965L46.8106 19.2454H32V20.8747H46.8106L38.7617 28.9236L39.9185 30.0641L47.9674 22.0152V40.0519H49.5967V22.0152L57.6456 30.0641L58.7861 28.9236L50.7536 20.8747H65.5641V19.2454Z" fill="black"/>
      <path d="M97.3941 184.707H0L16.7567 136.531L17.7117 133.803L21.2347 123.659L22.9923 118.627L48.697 44.7065L63.311 86.7186L64.3061 89.5756L93.4617 173.399L94.834 177.347L97.3941 184.707Z" fill="url(#paint0_linear_101_2)"/>
      <path d="M30.4715 169.483C30.4715 169.883 30.3927 170.28 30.2394 170.65C30.0862 171.02 29.8615 171.356 29.5783 171.639C29.2952 171.922 28.959 172.147 28.589 172.3C28.219 172.453 27.8224 172.532 27.422 172.532C26.6146 172.53 25.8409 172.208 25.2708 171.636C24.7006 171.065 24.3804 170.29 24.3804 169.483C24.3804 168.676 24.7009 167.902 25.2713 167.332C25.8417 166.762 26.6153 166.441 27.422 166.441C28.2294 166.441 29.0038 166.761 29.5755 167.332C30.1472 167.902 30.4694 168.675 30.4715 169.483Z" fill="#FFD939"/>
      <path d="M67.6927 135.006C67.6927 135.813 67.3723 136.586 66.8019 137.157C66.2315 137.727 65.4579 138.048 64.6512 138.048C63.8438 138.048 63.0693 137.728 62.4976 137.157C61.9259 136.587 61.6037 135.814 61.6016 135.006C61.6016 134.197 61.9229 133.422 62.4948 132.85C63.0667 132.278 63.8424 131.957 64.6512 131.957C65.4586 131.959 66.2322 132.281 66.8024 132.853C67.3726 133.424 67.6927 134.199 67.6927 135.006Z" fill="#FFD939"/>
      <path d="M45.8161 85.2896C45.8161 86.0963 45.4956 86.8699 44.9252 87.4403C44.3548 88.0107 43.5812 88.3312 42.7745 88.3312C42.3748 88.3322 41.9788 88.2543 41.6093 88.1018C41.2398 87.9493 40.9041 87.7253 40.6214 87.4427C40.3388 87.16 40.1148 86.8243 39.9623 86.4548C39.8098 86.0853 39.7319 85.6893 39.7329 85.2896C39.7329 84.4829 40.0534 83.7093 40.6238 83.1389C41.1942 82.5685 41.9678 82.248 42.7745 82.248C43.5812 82.248 44.3548 82.5685 44.9252 83.1389C45.4956 83.7093 45.8161 84.4829 45.8161 85.2896Z" fill="#FFD939"/>
      <path d="M94.8342 177.347L16.7568 136.531L17.7118 133.802L93.4619 173.399L94.8342 177.347Z" fill="white"/>
      <path d="M64.3062 89.5757L21.2349 123.659L22.9924 118.627L63.3111 86.7188L64.3062 89.5757Z" fill="white"/>
      <defs>
        <linearGradient id="paint0_linear_101_2" x1="95.3263" y1="47.6879" x2="-30.348" y2="135.128" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFD939"/>
          <stop offset="0.06" stop-color="#FFD33B"/>
          <stop offset="0.38" stop-color="#FFB145"/>
          <stop offset="0.65" stop-color="#FF9C4B"/>
          <stop offset="0.83" stop-color="#FF954D"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "Tree2",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: 'white'
      }
    },
  }
</script>

<style scoped lang="scss">
  .tree {
    position: absolute;
    z-index: 50;

    &.is-yellow {
      svg * {
        fill: $yellow;
      }
    }
    &.is-white {
      svg * {
        fill: white;
      }
    }
  }
</style>
